import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export const LiveArticleTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "live-article-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
LiveArticleTheme.displayName = "LiveArticleTheme";